module.exports = __webpack_public_path__ + "assets/img/rule-3.98bd9987.png";